import * as React from 'react'
import  './style.scss'

const Arrow = ({ onClick }) => (
  <svg
    className="arrow-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    onClick={onClick}
  >
    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
  </svg>
)

export default Arrow
